import { useEffect, useState } from 'preact/hooks';

// eslint-disable-next-line import/prefer-default-export
export const useWindowMediaQuery = (query: string, defaultValue: boolean = false) => {
  const [matches, setMatches] = useState(defaultValue);
  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handler = () => setMatches(mediaQuery.matches);
    handler();
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [query]);
  return matches;
};
